<template>
  <main id="page-wrap" class="bytesforslag">
    <div class="grid-container">
      <div class="grid-x align-center">
        <div class="cell small-12 medium-10 large-8">
          <h1>{{ $t('swaps.title') }}</h1>

          <div class="bf-filters">
            <div class="bf-filter-group">
              <h4>Storlek</h4>
              <div class="bf-chip-row">
                <button
                  v-for="size in availableSwapSizes"
                  :key="size"
                  type="button"
                  class="bf-chip"
                  :class="{ 'bf-chip--active': activeSwapSizes.includes(size) }"
                  @click="toggleSwapSize(size)"
                >
                  {{ sizeLabel(size) }}
                </button>
              </div>
            </div>

            <div class="bf-filter-group">
              <div class="bf-filter-head">
                <h4>Status</h4>
                <span v-if="suggestionsRefreshing" class="bf-refreshing">Uppdaterar…</span>
              </div>

              <!-- <MyCheckbox  v-for="bucket in bucketOrder" :key="bucket" label="hej"  /> -->

               <div  class="check-tag-wrap">
          <!-- <div
          v-for="bucket in bucketOrder"
                  :key="bucket"
            class="check-tag "
            style="--color-active: var(--color-secondary);"
            :class="{ active: activeBucket === bucket }"
            @click="selectBucket(bucket)">
            <div class="check-box">
              <svg xmlns="http://www.w3.org/2000/svg" width="9" height="8">
                <path
                  fill-rule="nonzero"
                  d="M7.68198052 1.31801905L3.08578644 5.91421312 1.31801948 4.14644617c-.19526188-.19526188-.51184631-.19526046-.70710678 0-.19526046.19526047-.19526188.5118449 0 .70710678L2.73223305 6.9748733c.19526258.19526258.51184631.19526046.70710678 0L8.3890873 2.02512583c.19526046-.19526047.19526258-.5118442 0-.70710678-.19526188-.19526188-.51184632-.19526047-.70710678 0z" />
              </svg>
            </div>
            <div class="check-label">
                {{ $t('swaps.buckets.' + bucket) }}
            </div>
          </div> -->
          </div>
              <div class="bf-chip-row" role="radiogroup">
                <!-- v-bind:disabled="bucketTotals[bucket] < 1" -->
                <button
                  v-for="bucket in bucketOrder"
                  :key="bucket"
                  type="button"
                  role="radio"
                  :aria-checked="activeBucket === bucket"
                  class="bf-chip"
                  :class="{ 'bf-chip--active': activeBucket === bucket }"
                  @click="selectBucket(bucket)"
                >
                {{ $t('swaps.buckets.' + bucket) }}
                  <span v-if="bucketTotals[bucket] != null" class="bf-chip__badge">
                    {{ bucketTotals[bucket] }}
                  </span>
                </button>
              </div>
            </div>
          </div>

          <div v-if="suggestionsLoading && !suggestions.length" class="bf-loading">
            {{ $t('general.loading') }}…
          </div>

          <div v-else-if="!suggestions.length" class="bf-empty">
            <p>{{ $t('swaps.empty') }}</p>
          </div>

          <div v-else class="bf-list">
            <SwapSuggestionItem
              v-for="s in suggestions"
              :key="s.to_ad_id"
              :suggestion="s"
            />
          </div>

          <div v-if="hasMore" class="bf-load-more">
            <button
              type="button"
              class="button"
              :disabled="suggestionsLoading"
              @click="loadMore"
            >
              {{ suggestionsLoading ? $t('general.loading') + '…' : $t('swaps.load-more') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import SwapSuggestionItem from '@/components/SwapSuggestionItem.vue'
import { swapSizeLabel } from '@/utils/swapMeta'

import MyCheckbox from '@/components/MyCheckbox.vue';

const BUCKET_ORDER = [
  'suggestion',
  'pending',
  'ready',
  'wants_to_swap_with_me',
  'wants_to_swap_with_me_outside_my_wishes',
  'rejected_by_me',
  // 'rejected_by_other',
  // 'archived_matches'
]

export default {
  name: 'Bytesforslag',
  components: {
    SwapSuggestionItem,
    MyCheckbox
  },
  data () {
    return {
      availableSwapSizes: [2, 3],
      bucketOrder: BUCKET_ORDER
    }
  },
  computed: {
    ...mapState('swaps', [
      'suggestions',
      'suggestionsLoading',
      'suggestionsRefreshing',
      'bucketTotals',
      'activeBucket',
      'activeSwapSizes'
    ]),
    ...mapGetters('swaps', ['hasMore', 'nextPage'])
  },
  mounted () {
    this.$store.dispatch('swaps/fetchSuggestions', { page: 1, append: false })
  },
  methods: {
    sizeLabel (size) {
      return swapSizeLabel(size)
    },
    selectBucket (bucket) {
      if (this.activeBucket === bucket) return
      this.$store.dispatch('swaps/setBucket', bucket)
    },
    toggleSwapSize (size) {
      const next = this.activeSwapSizes.includes(size)
        ? this.activeSwapSizes.filter(s => s !== size)
        : this.activeSwapSizes.concat(size).sort()
      if (!next.length) return
      this.$store.dispatch('swaps/setSwapSizes', next)
    },
    loadMore () {
      this.$store.dispatch('swaps/fetchSuggestions', {
        page: this.nextPage,
        append: true
      })
    }
  }
}
</script>

<style scoped>
.bytesforslag {
  margin-top: 74px;
  padding-bottom: 40px;
}

.bytesforslag h1 {
  margin-bottom: 16px;
}

.bf-filters {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 20px;
  padding: 16px;
  background: #fff;
  border-radius: 6px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
}

.bf-filter-group h4 {
  margin: 0 0 8px;
  font-size: 0.85rem;
  color: #555;
  font-weight: 600;
}

.bf-filter-head {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
}

.bf-refreshing {
  font-size: 0.75rem;
  color: #888;
  font-style: italic;
}

.bf-chip-row {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.bf-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  background: #f3f3f3;
  border: 1px solid transparent;
  border-radius: 16px;
  font-size: 0.85rem;
  color: #333;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease;
}
/* .bf-chip__disabled{
  cursor: not-allowed;
  opacity: 0.5;
} */

.bf-chip:hover {
  background: #e8e8e8;
}

.bf-chip--active {
  background: #e8f5f2;
  border-color: #64bcb2;
  color: #2a7a6d;
  font-weight: 600;
}

.bf-chip__badge {
  display: inline-block;
  padding: 1px 6px;
  background: rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  font-size: 0.72rem;
  font-weight: 600;
}

.bf-chip--active .bf-chip__badge {
  background: #64bcb2;
  color: #fff;
}

.bf-loading,
.bf-empty {
  padding: 32px 16px;
  text-align: center;
  color: #666;
  background: #fff;
  border-radius: 6px;
}

.bf-load-more {
  margin-top: 16px;
  text-align: center;
}
</style>
